import { render } from "./DirectorsAdmin.vue?vue&type=template&id=be34440a&scoped=true"
import script from "./DirectorsAdmin.vue?vue&type=script&lang=js"
export * from "./DirectorsAdmin.vue?vue&type=script&lang=js"

import "./DirectorsAdmin.vue?vue&type=style&index=0&id=be34440a&lang=scss&scoped=true"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be34440a"]])

export default __exports__